// extracted by mini-css-extract-plugin
export default {"devicesSelect":"BulkFailureCreateModal_devicesSelect__iSk2U"};